import { format } from "date-fns";

/**
 * ALL DATES CAN BE EITHER DATE OBJECTS OR IN MS
 */

export const dateNum = (date) => format(date, "dd");

export const dayName = (date) => format(date, "eeee");

export const dayNameShort = (date) => format(date, "eee");

export const monthNameShort = (date) => format(date, "MMM");

export const monthNum = (date) => format(date, "MM");

export const yearNum = (date) => format(date, "yyyy");

/* used at the border of calendar */
export const hr_minutes = (date, prefer24HourFormat) => {
  if (prefer24HourFormat) {
    return format(date, "HH:mm");
  }
  return format(date, "h a");
};

/* used in slots */
export const formatSlotDate = (date, prefer24HourFormat) => {
  if (prefer24HourFormat) {
    return format(date, "HH:mm");
  }
  return format(date, "h:mmaaaaa");
};

export const formatConnectionDate = (date) => format(date, "do MMM yyyy");

export const formatExclusionDate = (date) => {
  return format(date, "h:mmaaa, MMM do");
};

export const formatLastSavedDate = (date) => format(date, "do MMMM, yyyy");

export const formatJoinDate = (date) => format(date, "MMMM dd, yyyy");

export const formatDayMonthYear = (date) => format(date, "do MMMM, yyyy");
export const formatMonthDayYear = (date) => format(date, "MMMM d, yyyy");
